/*
 * ************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *   Copyright 2021 Adobe Systems Incorporated
 *   All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by all applicable intellectual property
 * laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 * ************************************************************************
 */

import * as R from 'ramda';
import { createAction } from 'redux-actions';

import ReduxStorage, { SCOPE, reducer as defaultReducer } from '@nebula/dorado-redux-storage';

const RESET_ACTION = 'DORADO.reset.stateful';

export const reset = createAction(RESET_ACTION);

export const reducer = (state, action) => {
  if (action.type === RESET_ACTION) {
    return R.assoc(SCOPE, {}, state);
  }
  return defaultReducer(state, action);
};

export default new ReduxStorage();
